import { NgModule } from '@angular/core';
import { AccessCodeModule } from '@spaq/modules/access-code';
import { ContractModule } from '@spaq/modules/contract';
import { EmailModule } from '@spaq/modules/email';
import { FaqModule } from '@spaq/modules/faq';
import { OrganizationsModule } from '@spaq/modules/organization';
import { ParksModule } from '@spaq/modules/parks';
import { PasswordModule } from '@spaq/modules/password';
import { ProfileModule } from '@spaq/modules/profile';
import { RegisterModule } from '@spaq/modules/register';
import { ServicesModule } from '@spaq/modules/services';
import { SubscriptionModule } from '@spaq/modules/subscription';
import { UserModule } from '@spaq/modules/user';
import { UtilsModule } from '@spaq/modules/utils';
import { VehiclesModule } from '@spaq/modules/vehicles';

@NgModule({
	imports: [
		SubscriptionModule.forRoot(),
		ParksModule.forRoot(),
		ContractModule.forRoot(),
		EmailModule.forRoot(),
		ServicesModule.forRoot(),
		UserModule.forRoot(),
		OrganizationsModule.forRoot(),
		AccessCodeModule.forRoot(),
		PasswordModule.forRoot(),
		FaqModule.forRoot(),
		VehiclesModule.forRoot(),
		ProfileModule.forRoot(),
		RegisterModule.forRoot(),
		UtilsModule
	],
	exports: [],
	declarations: []
})
export class FeaturesModule {}
